import { type ISelectProps, Select } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type BudgetIntervalType } from '@webapp/models/enums/BudgetInterval'
import { useBudgetIntervalOptions } from './hooks/useBudgetIntervalOptions'
import messages from './messages'
import { BudgetIntervalSelectStyled } from './styles/BudgetIntervalSelectStyled'

export interface IBudgetIntervalSelectProps
  extends ISelectProps<BudgetIntervalOption> {}

export interface BudgetIntervalOption {
  value: BudgetIntervalType
  label: string
}

export const BudgetIntervalSelect = ({
  ...props
}: IBudgetIntervalSelectProps) => {
  const intl = useProcurifyIntl()
  const budgetIntervalOptions = useBudgetIntervalOptions()

  return (
    <BudgetIntervalSelectStyled>
      <Select<BudgetIntervalOption>
        placeholder={intl.formatMessage(
          messages.budgetIntervalSelectPlaceholder
        )}
        options={budgetIntervalOptions}
        getOptionValue={(option) => option.value.toString()}
        isClearable
        {...props}
      />
    </BudgetIntervalSelectStyled>
  )
}

BudgetIntervalSelect.displayName = 'BudgetIntervalSelect'
